import API from '../../../manager/API';
import { dispatch } from '../../hooks';
import slice from './slice';

export const { setModelSummaryArraysData, setModelSummaryArraysStatus } = slice.actions;

const getModelSummaryArrays = (url: any) => async () => {
  try {
    const response = await API.modelSummaryArrays.getModelSummaryArrays(url);
    dispatch(setModelSummaryArraysData(response.data));
    dispatch(setModelSummaryArraysStatus(response.status));
    return { response, status: response.status, data: response.data };
  } catch (error) {}
};

export default {
  getModelSummaryArrays
};
